export default function Skeleton() {
    return (
        <div className="min-h-[200px] flex items-center justify-center">
            <div className="animate-pulse space-y-6 w-full">
                <div className="h-14 bg-gray-200 rounded w-full"></div>
                <div className="h-14 bg-gray-200 rounded w-full"></div>
                <div className="h-14 bg-gray-200 rounded w-full"></div>
                <div className="h-14 bg-gray-200 rounded w-full"></div>
                <div className="h-14 bg-gray-200 rounded w-full"></div>
            </div>
        </div>
    );
}
